import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Offer.css';
const Offer = () => {
    return (
        <section className='offer overflow-hidden'>
            <Container>
            <div className="offer-content">
            <h5>Exclusive Offers</h5>
            <h1>Get Upto <span>50%</span> Back on Purchase</h1>
            <p>Launched!</p>
            <Link to="/watches"><button className='offer-btn'>Shop Now</button></Link>
            </div>
            </Container>
        </section>
    );
};

export default Offer;